import { render, staticRenderFns } from "./Entrepreneur.vue?vue&type=template&id=0d2b7d2d&scoped=true&"
import script from "./Entrepreneur.vue?vue&type=script&lang=js&"
export * from "./Entrepreneur.vue?vue&type=script&lang=js&"
import style0 from "./Entrepreneur.vue?vue&type=style&index=0&id=0d2b7d2d&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2b7d2d",
  null
  
)

export default component.exports